import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class RequestTypeService {
  constructor(private apiHttp: ApiHttpService) { }

  public getAll = (): Observable<RequestType[]> => {
    return this.apiHttp.get<RequestType[]>("requesttypes");
  };

  public get = (id: number): Observable<RequestType> => {
    return this.apiHttp.get<RequestType>(`requesttypes/${id}`);
  }

}

export interface RequestType {
  id: number;
  name: string;
  isActive: boolean;
  order: number;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/request-type.service.ts